export default "__VITE_ASSET__Cdx2rH1a__"